import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';
import { ProgramManagementPage } from '@/features/programs/program-management/ProgramManagementPage';
import { programManagementSearchSchema } from '@/features/programs/program-management/program-management-search.schema';
import {
  ProgramByIdFetchError,
  programByIdQueryOptions,
} from '@/features/programs/program-edit/program-by-id-query';

// EU-593 — "Gerenciar programa": destino do clique no programa na listagem,
// substituindo a entrada direta no formulário (que segue em
// `/programas/$programId/editar`, alcançado pelo botão Editar/Conferir).
export const programManagementRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/programas/$programId',
  component: ProgramManagementPage,
  validateSearch: programManagementSearchSchema,
  loader: async ({ context, params }) => {
    try {
      await context.query.ensureQueryData(programByIdQueryOptions(params.programId));
    } catch (err) {
      // Programa inexistente/fora do escopo (404) volta pra listagem — mesmo
      // comportamento do fluxo de edição (RN-15).
      if (err instanceof ProgramByIdFetchError && err.status === 404) {
        throw redirect({ to: '/programas', replace: true });
      }
      throw err;
    }
  },
});
